import { ca } from '@cian/analytics';

import { TCallbackOpener } from '../../types/callbackPopup';

interface IUser {
  userId?: number;
  extra?: {
    [ket: string]: string | number | boolean;
  };
}

interface ITrackCallbackSendParams {
  label: string;
  placeType: TCallbackOpener;
  user: IUser;
}

export function trackCallbackSend({ label, placeType, user }: ITrackCallbackSendParams) {
  ca('eventSite', {
    action: `CallBack_popup_send_${placeType}`,
    category: 'Card',
    label,
    name: 'oldevent',
    user,
    useLastProducts: true,
  });
}
